import { SalesOrderDTO, Permission, DocumentType } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import * as SalesOrderStore from './SalesOrderStore';
import { Command } from 'pos/common';
import { printDocument } from 'pos/modules/helpers/document-printing';
import { PrintFacade } from 'pos/facades';

declare global {
	interface CommandType {
		printSalesOrder: (order: SalesOrderDTO) => Promise<Result>
	}
}

Command.register('printSalesOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Print), Preconditions.ensureIsNotLite), async (order: SalesOrderDTO): Promise<Result> => {
	const options = await PrintFacade.getPrintOptions(DocumentType.SalesOrder);
	return printDocument({
		getOptions: () => options,
		print: params => SalesOrderStore.print(order.Id, params)
	});
});